import * as PatientService from '../../service/PatientService'
import  * as types from '../mutation-types'
// import {setDefaultAddress,getDefaultAddress} from '../../utils/util'
const state = {
	patientList:[],
	pageNo:1,
	shopList:[],
	patientLabels:[],
	doctorLabels:[],
	patientPersonLabel:[]
}
const getters = {
	doctorLabels:()=>state.doctorLabels,
	patientLabels:()=>state.patientLabels,
	patientList:()=>state.patientList,
	patientPersonLabel:()=>state.patientPersonLabel
}
const mutations = {
		[types.GET_PATIENT_LIST](state,{pageNo,list}){
			if(pageNo===1){
				state.patientList = [...list]
			}else{
				state.patientList = [...state.patientList,...list]
			}
			state.pageNo = ++pageNo
		},
		[types.GET_DOCTOR_LABEL_LIST](state,{doctorLabels}){
			state.doctorLabels = doctorLabels
		},
		[types.ADD_DOCTOR_LABEL](state,{newLabel}){
			state.doctorLabels = [...state.doctorLabels,newLabel]
		},
		[types.DETELE_DOCTOR_LABEL](state,labelId){
			let newList = state.doctorLabels.filter(item=>item.id!==labelId)
			state.doctorLabels = newList
		},
		[types.GET_PATIENT_LABEL_LIST](state,{patientLabels}){
			state.patientLabels = patientLabels
		},
		[types.CHECK_PATIENT_LABELS](state,labels){
			state.patientPersonLabel = labels
		},
		[types.ADD_PATIENT_LABEL](state,{patientId,newLabel}){
			let patientList = [...state.patientList]
			let newList = patientList.map(item=>{
				if(item.patientId===patientId){
					let labels = item.labels ||[]
					labels.push(newLabel)
					item.labels = labels
				}
				return item
			})
			state.patientList = newList
			state.patientLabels = [...state.patientLabels,newLabel]
		},
		[types.DETELE_PATIENT_LABEL](state,{patientId,labelId}){
			let newPatientList = state.patientList.map(item=>{
				if(item.patientId===patientId){
					item.labels = item.labels.filter(v=>v.id!==labelId)
					state.patientPersonLabel = item.labels
				}
				return item
			})
			let newLabels = state.patientLabels.filter(item=>item.id!==labelId)
			state.patientList = newPatientList
			state.patientLabels = newLabels
		}
}

const actions ={
	initPatientList({commit,state},labels){
		return PatientService.getPatientList(labels,1).then(res=>{
			commit(types.GET_PATIENT_LIST,{pageNo:1,list:res})
			return res
		},rea=>{
			return Promise.reject(rea)
		})
	},
	getPatientList({commit,state},labels){
		return PatientService.getPatientList(labels,state.pageNo).then(res=>{
			commit(types.GET_PATIENT_LIST,{pageNo:state.pageNo,list:res})
			return res
		},rea=>{
			return Promise.reject(rea)
		})
	},
	getDoctorLabelList({commit,state}){
		return PatientService.getDoctorLabelList()
			.then(res=>{
				commit(types.GET_DOCTOR_LABEL_LIST,{doctorLabels:res})
				return res
			},rea=>{
				return Promise.reject(rea)
			})
	},
	deleteDoctorLabel({commit,state},labelId){
		return PatientService.updateDoctorLabel({labelId:labelId,option:'delete'})
			.then(res=>{
				commit(types.DETELE_DOCTOR_LABEL,labelId)
				return res
			},rea=>{
				return Promise.reject(rea)
			})
	},
	checkPatientLabel({commit,state},labels){
		commit(types.CHECK_PATIENT_LABELS,labels)
	},
	addDoctorLabel({commit,state},label){
		return PatientService.updateDoctorLabel({content:label,option:'add'}).then(res=>{
			commit(types.ADD_DOCTOR_LABEL,{newLabel:res})
			return res
		},rea=>{
			return Promise.reject(rea)
		})
	},
	getPatientLabelList({commit,state}){
		return PatientService.getPatientLabelList()
			.then(res=>{
				commit(types.GET_PATIENT_LABEL_LIST,{patientLabels:res.data})
				return res.data
			},rea=>{
				return Promise.reject(rea)
			})
	},
	deletePatientLabel({commit,state},{labelId='',patientId=''}){
		return PatientService.updatePatientLabel({patientId:patientId,labelId:labelId,option:'delete'})
			.then(res=>{
				commit(types.DETELE_PATIENT_LABEL,{patientId,labelId})
				return res
			},rea=>{
				return Promise.reject(rea)
			})
	},
	addPatientLabel({commit,state},{label='',patientId=''}){
		return PatientService.updatePatientLabel({patientId:patientId,content:label,option:'add'}).then(res=>{
			commit(types.ADD_PATIENT_LABEL,{patientId:patientId,newLabel:res})
			return res
		},rea=>{
			return Promise.reject(rea)
		})
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
